import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import WpAPI from "../../WpApi";
import { updateUser } from "../../services/actions/actions";
import { setMembershipData } from "../../services/actions/actions";

const Empty = (props) => {
    const dispatch = useDispatch();
    useEffect(() => {
        WpAPI.isLoggedIn() &&  WpAPI.getLoginUserInfo().then(res => {
            dispatch(updateUser(res.data.user));
            const currentAccount = {
                plan: 'pro', 
                lastsync: Math.floor(Date.now() / 1000), 
                has_plan: true,
                plan_has_trial: false,
                plan_status: 'active'
            }
            dispatch(setMembershipData(currentAccount));
        });
    }, []);

	if (props.redirect_to) {
		return <Redirect to={props.redirect_to} />;
	}
	return <></>;
};

export default connect((state) => state)(Empty);
